import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {map, Observable} from 'rxjs';
import {Proposal} from '../../model/proposal/proposal';

@Injectable({
  providedIn: 'root'
})
export class TransmissionService {

  private readonly transmissionUrl = `${environment.backend}/v1/transmissions`;

  constructor(private readonly http: HttpClient) {
  }

  public loadProposalTransmission(id: string, secret: string): Observable<Proposal> {
    return this.getTransmission(id, secret).pipe(map(transmissionObject => {
      try {
        let objectString: string = JSON.stringify(transmissionObject);
        let proposal: Proposal = JSON.parse(objectString);
        return proposal;
      } catch (e) {
        let errorMsg = 'Tried to load transmission object of unrecognized type with id ' + id;
        console.error(errorMsg, transmissionObject);
        throw new Error(errorMsg);
      }
    }));
  }

  public getTransmission(id: string, secret: string): Observable<Object> {
    return this.http.get<Object>(this.transmissionUrl, {params: new HttpParams().set('id', id).set('secret', secret)});
  }

}
